enum IMGAE_QUALITY {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low'
}

export default IMGAE_QUALITY;